import URL from 'url';
import * as Sentry from '@sentry/browser';
import logToDataDog from '../logToDataDog';

export async function logErrorToDataDog() {
    let page;
    try {
        if (typeof window !== 'undefined') {
            const url = window.location.href;
            const parsedUrl = URL.parse(url);
            const splitPath = parsedUrl.pathname.split('/');
            if (splitPath.length > 2) {
                page = splitPath[2];
            } else if (splitPath.length === 2 && splitPath[1]) {
                page = splitPath[1];
            } else {
                page = 'unknown';
            }
        }

        const event = {
            name: 'booking-web-app.error',
            type: 'increment',
            value: 1,
            tags: [`page:${page}`, `ssr:${typeof window === 'undefined'}`],
        };
        logToDataDog(event);
    } catch (error) {
        if (typeof window !== 'undefined') {
            const { SENTRY_DSN } = window && window.ZD ? window.ZD.configs : {};
            if (SENTRY_DSN) {
                Sentry.withScope((scope) => {
                    scope.setExtras({ page });
                    Sentry.captureException(error);
                });
            }
        }
    }
}
